import { css } from "lit";
import { customElement } from "lit/decorators.js";
import { BasicButton } from "./BasicButton.js";

@customElement("success-button")
class SuccessButton extends BasicButton {
	static readonly styles = [
		BasicButton.styles,
		css`
            button {
                background: var(--color-mint);
                color: black;
            }
            
            button:hover:not(:disabled) {
                background: var(--color-lime);
                box-shadow: 0 4px 15px rgba(159, 231, 204, 0.3);
                color: black; 
            }
        `
	];
}

export default SuccessButton;